<template>
<div>
	<div class="title">{{title||'申请人信息'}}</div>
	<Form :model="form" :label-width="120" class="mt15" :rules="formRules" ref="form">
	    <FormItem label="企业名称" prop="subjectName">
	        <Input
				class="w450"
	        	v-model.trim="form.subjectName" 
	        	placeholder="请输入投保企业名称"
				@on-blur="balckBlur"
	        	:maxlength="50">
	        </Input>
	    </FormItem>
	    <FormItem label="社会统一信用代码" prop="idNumber">
	        <Input class="w450"
	        	v-model.trim="form.idNumber"
	        	placeholder="请输入18位证件号码（投保企业）"
				@on-change="value=>resetUpperCaseValue(value,'idNumber')"
				:maxlength="45"
				@on-blur="idCard"
	        	></Input>
	    </FormItem>
		<FormItem label="公司地址" prop="areaCode">
			<div class="box">
				<Area class="w450" v-model="form.areaCode" placeholder="请选择省市区" @get-city-str="areaChange"/>
				<Tooltip class="ml15" max-width="300" content="注：当前保险产品仅支持山东企业投保" placement="right-start">
					<Icon size="20" type="ios-help-circle-outline" />
				</Tooltip>
			</div>
		</FormItem>
	    <FormItem label="详细地址" prop="address">
	        <Input class="w450" v-model.trim="form.address" placeholder="请输入详细地址" @on-blur="change" :maxlength="80"></Input>
	    </FormItem>
	    <FormItem label="联系人" prop="contactName">
	        <Input class="w450" v-model.trim="form.contactName" placeholder="请输入联系人" :maxlength="20"></Input>
	    </FormItem>
	    <FormItem label="联系电话" prop="contactPhone">
	        <Input class="w450" v-model.trim="form.contactPhone" placeholder="请输入手机号" @on-blur="change" :maxlength="20"></Input>
	    </FormItem>
	</Form>
</div>
</template>
<script>
import Area from './Area'
export default {
	components:{ Area },
	props:{
		info: Object,
		title:String
	},
	data () {
		return {
			form:this.info||{},
			formRules:{
				subjectName:[{required:true,message:'公司名称必填',trigger:'blur'}],
				idNumber:[
					{required:true,message:'请填写证件号码',trigger:'blur'},
					// {message:'格式错误',trigger:'blur',pattern:this.rules.idNumber}
					{message:'统一社会信用代码格式错误',trigger:'blur',pattern:this.rules.organizationCode}
				],
                address:[{required:true,message:'详细地址必填（最少6位）',min:6,trigger:'blur'}],
				contactName:[{required:true,message:'联系人姓名必填',trigger:'blur'},{message:'请输入至少2个字',trigger:'blur',pattern:this.rules.chinaName}],
				contactPhone:[{required:true,message:'请填写正确的手机号',trigger:'blur',pattern:this.rules.telOrPhone}],
				areaCode:[{required:true,message:'请选择地区',trigger:'change'}]
			}
		}
	},
	methods:{
		balckBlur(){
			// 统一社会信用代码校验
			if(this.form.subjectName&&this.form.idNumber){
				this.$emit('on-checkBlacklistchange',{
					companyName: this.form.subjectName,
					orgNumber: this.form.idNumber
				})
				this.$emit('on-change',this.form)
			}
		},
		idCard(){
			if(this.form.subjectName&&this.form.idNumber){
				this.$emit('on-checkBlacklistchange',{
					companyName: this.form.subjectName,
					orgNumber: this.form.idNumber
				})
			}
			this.$emit('on-change',this.form)
			this.$emit('getInvoice',this.form.idNumber)
		},
		// 上传回调方法
		uploadSuccess(val,key){
			this.$set(this.form,key,val.url)
			this.$refs.form.validateField(key);
		},
		// 草稿箱
		drafts(){
			return new Promise ((resolve,rejct)=>{
				resolve(this.form)
			})
		},
		// 校验
		val () {
			return new Promise ((resolve,rejct)=>{
				this.$refs.form.validate(valid=>{
					resolve(valid?this.form:false)
				})
			})
		},
		// 回传给父组件，父组件传入开票组件，开票组件的公司名称和社会代码用此组件的值
		change() {
			this.$emit('on-change',this.form)
		},
		getInfo (subjectName) {
			this.$post('/insurance2b/insurance/queryUserInfo',res=>{
				if(!res.data)return;
				this.$emit('on-data',res.data);
				this.$set(this.form,'idNumber',res.data.idNumber)
				this.$set(this.form,'areaCode',res.data.areaCode)
				this.$set(this.form,'address',res.data.address)
				this.$set(this.form,'contactName',res.data.contactName)
				this.$set(this.form,'contactPhone',res.data.contactPhone)
				if(res.data.invoiceType){
				    res.data.invoiceType += '';
				    this.$set(this.form,'invoiceType',res.data.invoiceType)
				    this.$set(this.form,'invoiceName',res.data.invoiceName)
				    this.$set(this.form,'taxpayerCode',res.data.taxpayerCode)
				    this.$set(this.form,'invoiceAddress',res.data.invoiceAddress)
				    this.$set(this.form,'invoicePhone',res.data.invoicePhone)
				    this.$set(this.form,'invoiceBank',res.data.invoiceBank)
				    this.$set(this.form,'publicAccount',res.data.publicAccount)
				}
			},{
				subjectName:this.form.subjectName
			})
		},
		areaChange(val){
			this.form.provinceCode=val[0].value
			this.form.provinceName=val[0].label
			this.form.cityCode=val[1].value
			this.form.cityName=val[1].label
			this.form.areaName=val[2].label
		},
		// 小写转大写
		resetUpperCaseValue(event,value){
			if(event.target.value){
				this.$set(this.form,value,event.target.value.toUpperCase())
			}
		}
	},
	watch:{
		info (v) {
			this.form = v;
		},
	}
}
</script>
<style scoped lang="less">
	.upload-img-main{
		padding:10px 0;
	}
	.box{
		width: 100%;
		display: flex;
		align-items: center;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/ApplicantCcic_M5.vue